import {
  Editor,
  Transforms,
  Node
} from 'slate';
import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import HelptapEditor from '../';

export function getDefaultOptions() {

  return basicEditorValueSerializer.utilities.node.youtube.getDefaultOptions();

}

export function buildNode(videoId) {

  return basicEditorValueSerializer.utilities.node.youtube.buildNode(videoId);

}

export function select(editor, path) {

  const node = Node.get(editor, path);

  const lastChildPath = [...path, node.children.length - 1];

  Transforms.select(editor, lastChildPath);
  Transforms.collapse(editor, { edge: 'end' });

}

export function insert(editor, path) {

  HelptapEditor.insertParagraph(editor, {}, path);
  Transforms.select(editor, [...path, 0]);
}

export function toggle(editor) {

  const nodeOptions = buildNode();

  HelptapEditor.setNodeOptions(editor, nodeOptions);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function replace(editor, path) {

  Editor.withoutNormalizing(editor, () => {

    Transforms.removeNodes(editor, { at: path });
    insert(editor, path);

  });

}